import { render, staticRenderFns } from "./no_data_yet.vue?vue&type=template&id=133a6996&scoped=true"
import script from "./no_data_yet.vue?vue&type=script&lang=js"
export * from "./no_data_yet.vue?vue&type=script&lang=js"
import style0 from "./no_data_yet.vue?vue&type=style&index=0&id=133a6996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133a6996",
  null
  
)

export default component.exports